import { Card, CardContent } from "@mui/material";
import { useState } from "react";

const dishes = [
  {
    id: 1,
    name: "Tacos de Birria con Queso Fundido",
    image:
      "https://thebigmansworld.com/wp-content/uploads/2022/02/quesabirria-tacos-recipe.jpg",
    ingredients: [
      "Tortillas de maíz",
      "Carne de birria",
      "Queso fundido",
      "Cilantro",
      "Cebolla encurtida",
    ],
  },
  {
    id: 2,
    name: "Smash Burgers Gourmet",
    image:
      "https://phantom-expansion.unidadeditorial.es/118b2a617e40d8ff00ff8b3e28ee6455/crop/0x0/2044x1363/resize/1200/f/webp/assets/multimedia/imagenes/2021/12/07/16389099071788.jpg",
    ingredients: [
      "Carne de res",
      "Pan brioche",
      "Queso cheddar",
      "Salsa especial",
      "Pepinillos",
    ],
  },
  {
    id: 3,
    name: "Arepas Rellenas Fusión",
    image: "https://imag.bonviveur.com/arepas-venezolanas-caseras-rellenas.jpg",
    ingredients: [
      "Masa de maíz",
      "Pollo al chipotle",
      "Guacamole",
      "Pulled pork",
      "Coleslaw",
    ],
  },
  {
    id: 4,
    name: "Gyozas de Costilla BBQ",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgHNwc4U0GSexlV4MvhWZmo1wK4IisDMBKTw&s",
    ingredients: [
      "Masa de gyoza",
      "Costilla desmenuzada",
      "Salsa BBQ",
      "Cebollín",
      "Ajo",
    ],
  },
  {
    id: 5,
    name: "Burritos de Pollo Crispy",
    image: "https://campero.es/wp-content/uploads/2017/11/CRISPY_WRAP.png",
    ingredients: [
      "Tortilla de harina",
      "Pollo crujiente",
      "Pico de gallo",
      "Queso fundido",
      "Salsa cremosa",
    ],
  },
  {
    id: 6,
    name: "Papas Locas (Loaded Fries)",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRdnHKj2harBWgiY_mqsTejXd3rHBwExEhVQ&s",
    ingredients: [
      "Papas fritas",
      "Pulled pork",
      "Salsa cheddar",
      "Jalapeños",
      "Alioli",
    ],
  },
  {
    id: 7,
    name: "Alitas de Pollo con Salsas Creativas",
    image:
      "https://cdn.recetasderechupete.com/wp-content/uploads/2018/06/alitas-de-pollo-horno.jpg",
    ingredients: [
      "Alitas de pollo",
      "Salsa miel-sriracha",
      "Salsa parmesano-ajo",
      "Salsa limón-pepper",
    ],
  },
  {
    id: 8,
    name: "Tacos de Camarón Crunchy",
    image: "/images/tacos-camaron.jpg",
    ingredients: [
      "Tortillas de maíz",
      "Camarones empanizados",
      "Col morada",
      "Alioli de chipotle",
    ],
  },
  {
    id: 9,
    name: "Sándwich Cubano de Cerdo",
    image: "/images/sandwich-cubano.jpg",
    ingredients: [
      "Pan cubano",
      "Cerdo asado",
      "Jamón",
      "Queso suizo",
      "Pepinillos",
      "Mostaza",
    ],
  },
  {
    id: 10,
    name: "Aguas Frescas y Mocktails",
    image: "/images/aguas-frescas.jpg",
    ingredients: [
      "Horchata",
      "Agua de jamaica",
      "Limonada de maracuyá",
      "Frutas frescas",
    ],
  },
  {
    id: 11,
    name: "Churros con Chocolate",
    image: "/images/churros.jpg",
    ingredients: [
      "Masa para churros",
      "Azúcar",
      "Canela",
      "Chocolate caliente",
    ],
  },
  {
    id: 12,
    name: "Bao de Panceta",
    image: "/images/bao-panceta.jpg",
    ingredients: [
      "Pan bao",
      "Panceta de cerdo",
      "Pepinillos",
      "Mayonesa de sésamo",
    ],
  },
  {
    id: 13,
    name: "Hot Dogs Artesanales",
    image: "/images/hotdog.jpg",
    ingredients: [
      "Pan de hot dog",
      "Salchicha artesanal",
      "Cebolla crispy",
      "Salsa especial",
    ],
  },
  {
    id: 14,
    name: "Nachos con Todo",
    image: "/images/nachos.jpg",
    ingredients: [
      "Totopos",
      "Carne molida",
      "Queso fundido",
      "Guacamole",
      "Crema agria",
    ],
  },
  {
    id: 15,
    name: "Empanadas Criollas",
    image: "/images/empanadas.jpg",
    ingredients: [
      "Masa de maíz",
      "Carne picada",
      "Aceitunas",
      "Huevos",
      "Especias",
    ],
  },
  {
    id: 16,
    name: "Pizza al Taglio",
    image: "/images/pizza.jpg",
    ingredients: [
      "Masa de pizza",
      "Salsa de tomate",
      "Mozzarella",
      "Toppings variados",
    ],
  },
  {
    id: 17,
    name: "Poke Bowl",
    image: "/images/poke.jpg",
    ingredients: [
      "Arroz de sushi",
      "Atún marinado",
      "Aguacate",
      "Pepino",
      "Salsa de soja",
    ],
  },
  {
    id: 18,
    name: "Falafel Wrap",
    image: "/images/falafel.jpg",
    ingredients: ["Pan pita", "Falafel", "Ensalada", "Tahini", "Salsa picante"],
  },
  {
    id: 19,
    name: "Crepes Dulces y Salados",
    image: "/images/crepes.jpg",
    ingredients: ["Masa de crepes", "Rellenos dulces", "Rellenos salados"],
  },
  {
    id: 20,
    name: "Tostadas de Aguacate",
    image: "/images/tostadas.jpg",
    ingredients: [
      "Pan artesanal",
      "Aguacate",
      "Tomate cherry",
      "Huevo pochado",
    ],
  },
];
export default function FoodTruckMenu() {
  const [search, setSearch] = useState("");

  const filteredDishes = dishes.filter((dish) =>
    dish.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        padding: "24px",
        background: "linear-gradient(to bottom, #FFFAE5, #FFF3C6)",
        height: "100vh",
        overflowY: "scroll",
      }}
    >
      <input
        type="text"
        placeholder="Buscar plato..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          padding: "12px",
          marginBottom: "24px",
          width: "100%",
          border: "2px solid #FFD700",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          outline: "none",
        }}
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "24px",
        }}
      >
        {filteredDishes.map((dish) => (
          <Card
            key={dish.id}
            style={{
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s",
              borderRadius: "16px",
            }}
          >
            <img
              src={dish.image}
              alt={dish.name}
              style={{
                width: "100%",
                height: "224px",
                objectFit: "cover",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            />
            <CardContent>
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "16px",
                  color: "#B8860B",
                }}
              >
                {dish.id}. {dish.name}
              </h2>
              <ul style={{ paddingLeft: "20px", color: "#4A4A4A" }}>
                {dish.ingredients.map((ingredient, index) => (
                  <li key={index}>{ingredient}</li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
